import React from "react";
import Link from "gatsby-link";
import FullLogoOnWhite from "./full-logo-on-white.svg";
import Fast from "./fast.svg";
import Languages from "./languages.svg";

const onSelectorChange = () => {
  document.location = "http://graphene-python.org/";
};

const IndexPage = () => (
  <div>
    <div className="hero container">
      <FullLogoOnWhite />
      <h1>Next Generation GraphQL Engine</h1>
      <a className="button primary" href="/signup">
        Get Started
      </a>
      {/* <a className="button">Download 2.0</a> */}
    </div>

    <section className="main">
      <div className="container">
        <span className="callout">Performance at its Finest</span>
        <h1>Built for scale</h1>
        <p>
          Quiver is a GraphQL engine that thanks to it’s sophisticated algorithm
          is able to compile your GraphQL queries down to the most atomic CPU
          operations.
        </p>
        <div className="main-subsection">
          <Fast />
          <div className="info">
            <h2>Fast and Scalable</h2>
            <p>
              Quiver is able to execute the GraphQL queries in the fastest way
              possible, with literally 0-overhead from the framework, and with
              code carefully optimized based on your needs.
            </p>
          </div>
        </div>
        <div className="main-subsection">
          <div className="info">
            <h2>Multiplatform</h2>
            <p>
              Quiver GraphQL engine is agnostic of your platform. Either if your
              backend is built on Python, JS or Ruby, Quiver is perfect for it.
              Thanks to it’s integration into Graphene frameworks, using it as
              simple as changing one line of code.
            </p>
          </div>
          <Languages />
        </div>
      </div>
    </section>
    <section className="contact-footer">
      <a className="button primary" href="/signup">
        Get Started
      </a>
    </section>
    {/* <section className="pluggable">
      <div className="container">
        <span className="callout">Pluggable</span>
        <h1>Extensible Framework</h1>
        <p>Graphene-JS will work out of the box with your current stack.</p>
        <p>
          For being able to have a fast development process, is essential to
          reuse as much code as possible.
        </p>

        <p>
          We offer integrations with different frameworks that will get you up
          to speed in the blink of an eye.<br />These integrations include:
          <ul>
            <li>
              <b>Sequelize</b>: Graphene-Sequelize
            </li>
          </ul>
        </p>
      </div>
    </section> */}

    <style jsx>{`
      /* Rectangle 5: */
      .main-subsection {
        height: 240px;
        justify-content: center;
        height: 100%;
        margin: 0 auto;
        display: flex;
      }
      .main-subsection h2 {
        font-weight: 600;
        text-transform: uppercase;
        font-size: 20px;
      }
      .main-subsection :global(svg) {
        vertical-align: middle;
        flex: 1;
      }
      .main-subsection .info {
        align-self: center;
        flex: 2;
        flex-direction: column;
      }
      .callout {
        background: #000000;
        color: #ffffff;
        display: inline-block;
        font-family: "klavika-web", Helvetica, sans-serif;
        font-size: 18px;
        font-weight: 400;
        line-height: 1;
        margin: 0;
        padding: 5px;
        letter-spacing: 0.05em;
        text-transform: uppercase;
      }
      .callout.inverse {
        color: #000000;
        background: #ffffff;
      }
      :global(.puzzle) {
        margin: 100px;
      }
      .main {
        position: relative;
        padding: 140px 0;
        color: white;
      }
      .hero {
        margin: 140px auto;
        display: block;
        text-align: center;
      }
      section h1 {
        font-size: 36px;
      }
      .hero h1 {
        font-weight: 400;
        font-size: 36px;
        color: #555555;
      }
      .hero select {
        width: 200px;
        position: relative;
        border: none;
        box-shadow: none;
        background: #ffffff;
        padding: 7px 14px;
        padding-right: 40px;
        border: 1px solid #979797;
        box-shadow: 4px 5px 0 0 #e5e5e5;
        color: #555555;
        font-family: "klavika-web", Helvetica, sans-serif;

        background: transparent;
        background-image: none;
        font-size: 36px;
        border-radius: 0;
        margin: 0 10px;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
      }
      .hero .hero-selector {
        position: relative;
      }
      .hero .hero-selector:after {
        content: "▼";
        font-size: 26px;
        position: absolute;
        right: 21px;
        top: 7px;
        pointer-events: none;
      }
      .hero .button {
        margin: 5px;
      }
      @media (max-width: 768px) {
        .hero .button {
          display: block;
          margin-top: 10px;
          text-align: center;
        }
      }
      .main .code {
        /* Rectangle 7: */
        background: #000000;
        border: 1px solid #ffffff;
        padding: 24px;
        box-shadow: 3px 4px 0 0 rgba(28, 28, 28, 0.17);
        font-family: "Fira Mono";
        font-size: 16px;
        color: #a3b1b2;
        letter-spacing: 0;
        overflow: auto;
      }
      .main .code :global(b) {
        color: white;
        font-weight: inherit;
      }
      section p {
        font-weight: 300;
        font-size: 16px;
        letter-spacing: 0.01em;
        line-height: 1.8;
        margin: 0 0 10px;
      }

      .main:before {
        content: "";
        display: block;
        position: absolute;
        transform: skew(0, -3deg);
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        z-index: -1;
        background-image: linear-gradient(-183deg, #2fbda3 0%, #1290a4 100%);
      }
      .pluggable {
        padding: 140px 0;
        color: black;
      }
      .contact-footer {
        padding: 140px 0;
        text-align: center;
      }
      .contact-footer .button {
        margin: 0 auto;
      }

      .trustedby:before {
        content: "";
        display: block;
        position: absolute;
        transform: skew(0, 3deg);
        top: 50px;
        left: 0;
        bottom: -50px;
        right: 0;
        z-index: -1;
        background: black;
      }
      .trustedby .logos {
        display: flex;
        justify-content: space-between;
        padding-top: 40px;
      }
      :global(.trustedby .logos svg) {
        height: 90px;
        margin: 0 15px;
      }
      :global(.trustedby .logos svg g) {
        fill: #eee;
      }
      .logos svg {
        display: none;
      }
      .main h1 {
        color: white;
      }
    `}</style>
  </div>
);

export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/index.js